import React, { useEffect, useState } from 'react';
import AxiosInstance from '../../../Helper/AxiosInstance';
import { showDate } from '../../../Helper/Functions';
import { WithdrawalModal } from '../../../Helper/Modal';
import { C, fBody } from '../../../Shared/Brand';
import { PageHeader, StatRow, StatCard, TableWrap, EmptyState } from '../../../Shared/DashboardUI';

export default function Withdrawal() {
   const [data, setData] = useState([])
   const [action, setAction] = useState({ open: null })

   const fetchData = async () => {
      try {
         const response = await AxiosInstance.get('/report?type=withdraw');
         if (response.status === 1) { setData(response.data) }
      } catch (err) { }
   }
   useEffect(() => { fetchData() }, [])
   return (
      <>
         <PageHeader
            title="Withdrawal"
            action={<button className="xdb-btn" onClick={() => setAction((prev) => ({ ...prev, open: true }))}>Withdrawal Now</button>}
         />
         <StatRow>
            <StatCard label="Total Withdrawal" value="$0.00" icon="ri-download-2-line" />
            <StatCard label="Pending Withdrawal" value="0" icon="ri-time-line" />
            <StatCard label="Approved Withdrawal" value="0" icon="ri-check-double-line" />
         </StatRow>
         <div className="xdb-card">
            <h5 style={{ fontSize: '14px', fontWeight: 700, color: C.ltx, marginTop: 0, marginBottom: '12px', fontFamily: fBody }}>Withdrawal Report</h5>
            <TableWrap>
               <thead>
                  <tr><th>#</th><th>Date</th><th>Wallet Address</th><th>Amount</th><th>Received</th><th>Status</th></tr>
               </thead>
               <tbody>
                  {(data || []).length === 0 ? (
                     <tr><td colSpan="6"><EmptyState /></td></tr>
                  ) : data.map((tr, ind) => (
                     <tr key={tr._id || ind}>
                        <td>{Number(ind + 1).toString().padStart(2, '0')}</td>
                        <td>{showDate(tr.createDate, 'd d m y')} <span style={{ color: C.ltx3 }}>{showDate(tr.createDate, 'h:m:sa')}</span></td>
                        <td>{tr.usdtaddress ? `${tr.usdtaddress.slice(0, 6)}....${tr.usdtaddress.slice(-6)}` : ''}</td>
                        <td style={{ color: C.primary }}>USDT{tr.totalamount}</td>
                        <td style={{ color: C.primary }}>USDT{tr.withdrawamount}</td>
                        <td style={{ color: tr.status === 'Pending' ? C.down : C.up }}>{tr.status}</td>
                     </tr>
                  ))}
               </tbody>
            </TableWrap>
         </div>
         <WithdrawalModal action={action} setAction={setAction} refresh={fetchData} />
      </>
   )
}
